import { useEffect, useState } from "react";
import axios from "../helpers/axios";

// Create an order
export const createOrder = async (values, callback) => {
  const res = await axios.post(`/order/createorder`, values);
  callback(res.data.response);
};

// Update an order
export const updateOrder = async (values, callback) => {
  const res = await axios.put(`/order/updateorder`, values);
  callback(res.data.response);
};

// Delete an order
export const deleteOrder = async (id, callback) => {
  const res = await axios.delete(`/order/deleteorder/${id}`);
  callback(res.data.response);
};

// Delete all orders for a specific customer
export const deleteAllOrders = async (customerId, callback) => {
  const res = await axios.delete(`/order/deleteallorder/${customerId}`);
  callback(res.data.response);
};

// Get all orders with pagination & search
export const getOrders = async (rowPerPage, pageNumber, search, status, callback) => {
  try {
    console.log("Fetching data...... ");
    const res = await axios.get(`/order/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}&status=${status}`);

    callback(res.data.response || { data: [], totalPage: 1 }); // Ensure empty data is handled
  } catch (error) {
    console.error("Error fetching orders:", error);
    callback({ data: [], totalPage: 1 }); // Prevents UI crash
  }
};

export const getOrdersByDateRange = async (rowPerPage, pageNumber, search, status, startDate, endDate, callback) => {
  try {
    const res = await axios.get(`/order/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}&status=${status}&startDate=${startDate}&endDate=${endDate}`);

    callback(res.data.response || { data: [], totalPage: 1 }); // Ensure empty data is handled
  } catch (error) {
    console.error("Error fetching orders:", error);
    callback({ data: [], totalPage: 1 }); // Prevents UI crash
  }
};

// Get orders for a specific customer
export const getCustomerOrders = async (customerId, callback) => {
  const res = await axios.get(`/order/getcustomerorder/${customerId}`);
  callback(res.data.response);
};

// Get a single order by ID
export const getOrderById = async (id, callback) => {
  const res = await axios.get(`/order/${id}`);
  callback(res.data.response);
};

// Orders API Hook for managing state
export const OrdersAPI = () => {
  const [orders, setOrders] = useState([]);
  const [orderDetail, setOrderDetail] = useState({});
  const [allOrders, setAllOrders] = useState([]);
  const [status, setStatus] = useState("");

  const [rowPerPage, setRowPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [callback, setCallback] = useState(false);
  const [customerId, setCustomerId] = useState(0);
  const [orderId, setOrderId] = useState(0);

  useEffect(() => {
    getCustomerOrders(customerId, (res) => {
      const filteredOrders = res.data?.filter((order) => order.status !== "Cancelled");
      setOrders(filteredOrders);
    });

    getOrders(rowPerPage, pageNumber, search, status, (res) => {
      setAllOrders(res.data.data);
      setTotalPages(res.totalPages || 1);
    });

    if (orderId) {
      getOrderById(orderId, (res) => {
        setOrderDetail(res.data);
      });
    }
  }, [callback, rowPerPage, search, status, pageNumber, customerId, orderId]);

  return {
    orders: [orders, setOrders],
    allOrders: [allOrders, setAllOrders],
    orderDetail: [orderDetail, setOrderDetail],
    rowPerPage: [rowPerPage, setRowPerPage],
    search: [search, setSearch],
    pageNumber: [pageNumber, setPageNumber],
    totalPages: [totalPages, setTotalPages],
    callback: [callback, setCallback],
    customerId: [customerId, setCustomerId],
    orderId: [orderId, setOrderId],
    status: [status, setStatus],
  };
};
